import { render, staticRenderFns } from "./ResponsiveContainer.vue?vue&type=template&id=12055926&scoped=true"
var script = {}
import style0 from "./ResponsiveContainer.vue?vue&type=style&index=0&id=12055926&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12055926",
  null
  
)

export default component.exports